/* @flow */
import React from 'react';
import { FormattedMessage } from 'react-intl';

type CreatedByProps = {|
    creatorName: string,
|};

const CreatedBy = ({ creatorName }: CreatedByProps) => (
    <span data-tn="portfolio-row-creator">
        <FormattedMessage
            id="dc.searchProductTile.createdBy"
            defaultMessage={`By {creatorName}`}
            values={{ creatorName }}
        />
    </span>
);

export default CreatedBy;
